import { useContext, useEffect, useState } from "react";
import { AppContext } from "@components/features/appContext/AppContext";
import { config } from "@utils/config";
import { languageOptions } from "@utils/translation";
import Button, { ButtonProps } from "../form/Button";

type Props = {
  buttonTheme?: ButtonProps["theme"];
};

function LanguageSelect({ buttonTheme }: Props) {
  const { language, setLanguage } = useContext(AppContext);
  const [currentLanguageIndex, setCurrentLanguageIndex] = useState(
    languageOptions.findIndex(
      (l: any) =>
        l.value === localStorage.getItem(config.localStorage.language) ||
        "nl_NL"
    )
  ) as any;
  const [currentLanguage, setCurrentLanguage] = useState(
    languageOptions.find(
      (l: any) =>
        l.value ===
        (localStorage.getItem(config.localStorage.language) || "nl_NL")
    )
  ) as any;

  useEffect(() => {
    if (!language) return;
    const languageIndex = languageOptions.findIndex(
      (l: any) => l.value === language
    );

    setCurrentLanguageIndex(languageIndex);
    setCurrentLanguage(languageOptions[languageIndex]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClick = () => {
    const newIndex = (currentLanguageIndex + 1) % languageOptions.length;
    const newLanguage = languageOptions[newIndex];

    setCurrentLanguageIndex(newIndex);
    setCurrentLanguage(newLanguage);

    setLanguage(newLanguage.value);
    localStorage.setItem(config.localStorage.language, newLanguage.value);
  };

  return (
    <Button onClick={handleOnClick} theme={buttonTheme}>
      {currentLanguage?.value === "nl_NL" && (
        <div
          style={{
            backgroundImage: "url(/images/flags/nl_NL.svg)",
            backgroundSize: "cover",
          }}
          className="w-[27px] h-[20px]"
        />
      )}

      {currentLanguage?.value === "en_US" && (
        <div
          style={{
            backgroundImage: "url(/images/flags/en_US.svg)",
            backgroundSize: "cover",
          }}
          className="w-[27px] h-[20px]"
        />
      )}
    </Button>
  );
}

export default LanguageSelect;
